import type { ComboboxOption } from '@atlas/ui-primitives'

/** The shape every geography source hands us: a bootstrap value or a rail option. */
interface GeoLike {
	code: string
	label: string
	depth: number
	meta?: Record<string, unknown>
	valueId?: string
}

/**
 * Geography values as combobox options: indented by hierarchy, with a country's ISO code
 * as its description.
 *
 * The ISO code used to be readable from the value's own code. The taxonomy reload made a
 * country `emea_es`, whose prefix names the REGION, so the country's own identifier had to
 * come from `meta.iso_country_code` — where the load records it — or be lost. It goes in
 * the DESCRIPTION rather than the label so the list still reads as country names, while
 * "ES" stays searchable and visible.
 *
 * `valueBy` picks what the option is worth: mapping writes address a geography by value
 * id, the work-order tuple by code.
 */
export function geoOptions(values: GeoLike[], valueBy: 'code' | 'valueId' = 'code'): ComboboxOption[] {
	return values.map((v) => {
		const iso = v.meta?.iso_country_code
		return {
			value: (valueBy === 'valueId' ? v.valueId : v.code) ?? v.code,
			label: v.label,
			depth: v.depth,
			...(typeof iso === 'string' && iso ? { description: iso } : {}),
		}
	})
}
